import { useEffect, type RefObject } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets a scrollable container to the top whenever the route changes.
 * Only fires on pathname change, so scrolling within the current view is untouched.
 */
export function useScrollToTopOnRouteChange(ref: RefObject<HTMLElement | null>): void {
  const location = useLocation();

  useEffect(() => {
    ref.current?.scrollTo({ top: 0 });
  }, [location.pathname, ref]);
}
